import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Paper,
    Divider,
    Button
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import { ToastContext, useToastContext } from "../../context/toastContext";



const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
};



export const CustomerFormStep4CustomerDetails = (props: any) => {
    const {setToast} = useToastContext() as ToastContext;    
    const navigate = useNavigate();
    const [customerInfo, setCustomerInfo] = useState(props?.customerInfo);
    const [siteInfo, setsiteInfo] = useState(props?.siteInfo);
    const [orderInfo, setOrderInfo] = useState(props?.orderInfo);

    return (
        <>
            <Paper
                elevation={3}
                sx={{
                    padding: '0',
                    background: "#03171F",
                    color: '#fff',
                    boxShadow: 'none',
                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="h6"
                            sx={{
                                fontSize: '16px',
                                color: '#B4B7B8',
                                fontWeight: '400',
                            }}
                        >Order Name: <span className="Titleinvo">{orderInfo?.orderName}</span></Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="h6"
                            sx={{
                                fontSize: '16px',
                                color: '#B4B7B8',
                                fontWeight: '400',
                            }}
                        >Order Reference: <span className="Titleinvo"></span></Typography>
                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="space-between" mb={2}>


                </Box>

                <Box mb={3}>
                    <Typography variant="subtitle1" gutterBottom className="CustomTl">
                        <b className="TitleInU">Customer Details</b>
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography className="InTit">Customer: <span className="Titleinvo">{customerInfo?.name}</span></Typography>
                            <Typography className="InTit">Address Line 1: <span className="Titleinvo">{customerInfo?.address?.addressline1}</span></Typography>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">City: <span className="Titleinvo">{customerInfo?.address?.city}</span></Typography>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">State / Province: - <span className="Titleinvo">{customerInfo?.address?.state}</span></Typography>
                                </Grid>
                            </Grid>
                            <Typography className="InTit">Phone Number: - <span className="Titleinvo">{customerInfo?.contact?.mobile?.[0]?.number}</span></Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography className="InTit">Email ID: <span className="Titleinvo">{customerInfo?.contact?.email?.[0]?.id}</span></Typography>
                            <Typography className="InTit">Address Line 2: <span className="Titleinvo">{customerInfo?.address?.addressline2}</span></Typography>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">Country: <span className="Titleinvo">{customerInfo?.address?.country}</span></Typography>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">Postal Code: <span className="Titleinvo">{customerInfo?.address?.postalcode}</span></Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                <Box mb={3}>
                    <Typography variant="subtitle1" gutterBottom className="CustomTl">
                        <b className="TitleInU">Site / Device Details</b>
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography className="InTit">Site / Device Name: <span className="Titleinvo">{siteInfo?.name}</span></Typography>
                            <Typography className="InTit"> Address Line 1: <span className="Titleinvo">{siteInfo?.address?.addressline1}</span></Typography>

                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">City: <span className="Titleinvo">{siteInfo?.address?.city}</span></Typography>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">State / Province: <span className="Titleinvo">{siteInfo?.address?.state}</span></Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">Phone Number: <span className="Titleinvo">{siteInfo?.contact?.phone?.number}</span></Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography className="InTit">Email ID: <span className="Titleinvo">{siteInfo?.contact?.email?.[0]?.id}</span></Typography>
                            <Typography className="InTit">Address Line 2: <span className="Titleinvo">{siteInfo?.address?.addressline2}</span></Typography>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">Country: <span className="Titleinvo">{siteInfo?.address?.country}</span></Typography>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">Postal Code: <span className="Titleinvo">{siteInfo?.address?.postalcode}</span></Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="InTit">Reference: <span className="Titleinvo"></span></Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Box>

                {/* <Box mb={3}>
                    <Typography variant="subtitle1" gutterBottom className="CustomTl">
                        <b className="TitleInU">Site / Device Admin Details</b>
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography className="InTit">Site/ Device Admin: <span className="Titleinvo">Jack Lee</span></Typography>

                            <Typography className="InTit">Mobile Number: -</Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography className="InTit">Email ID: <span className="Titleinvo">lms@amazon.com</span></Typography>


                        </Grid>
                    </Grid>
                </Box> */}
            </Paper>


            <Stack className="fStacky" direction="row" spacing={2} justifyContent="flex-end"
                sx={{
                    backgroundColor: '#03171F',
                    boxShadow: '-4px -4px 20px #91959621', borderTop: '1px solid #5A5F60', padding: 2,
                }}>
                <Button onClick={() => props.setActiveStep(2)} variant="outlined" sx={{ color: '#0699CE', height: '41px', lineHeight: '41px', border: '0', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                    Previous
                </Button>
                <Button onClick={() =>navigate("/customer/overview")} variant="outlined" sx={{ marginRight: 'auto !important', color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                    Cancel
                </Button>
                
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className="btnBlue"
                    sx={{
                        color: '#1F2F34', height: '41px', lineHeight: '41px',
                        borderColor: '#0B4A62',
                        borderRadius: '25px', fontSize: '14px', fontWidth: '500',
                    }}
                    onClick={() =>navigate("/customer/overview")}
                >
                    Ok
                </Button>
            </Stack>
        </>
    );
}

// DynamicCoPIRBFORM.propTypes = CoPiValuePropTypes;